import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import { insh as inshst } from "../../../Context/InshSt";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
import { sto } from "../../../Context/InshData";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";
import { uri } from "../../../help/Api";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { insh, wsto } from "../../../Context/InshData";
import TawlaForm from "./TawlaGroupsForm";
import TawlaTable from "./TawlaGroupsTable";
import PumpsAppbar from "../Pumps/PumpsAppbar";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.red[50],
        borderColor: colors.red[300],
    },
}));

export default function TawlaGroups(props) {
    const { AutoOptions,
        branch,
        setBranch,
        isGroups,
    } = props;
    const clasess = useStyles();
    const defaultBranch = AutoOptions.Branches.find((obj) => obj.id === sto.branchi);
    const { t } = useTranslation(["forms", "translation"]);
    // setBranch(defaultBranch);
    const typeTwala = [
        { id: 1, name: t("individuals") },
        { id: 2, name: t("families") },
        { id: 3, name: t("mixed") },

    ];

    const valueTwalat = {
        id: AutoOptions?.other?.lastid ?? 1,
        Name: "",
        Type:typeTwala[0].id,
        tawla_group: -1,
        branch: sto.branchi,
        create_user: sto.idi,
        update_user: null,
        update_date:null,
        date:moment(new Date()).format('YYYY-MM-DD'),

    };
    const tawlagroups=AutoOptions?.tawla_group??[];
    const AutoValueTawla = {
        tawla_group:isGroups?{}:tawlagroups[0],
        Type:typeTwala[0],
        branch: branch.id === -1 ? defaultBranch : branch,
    };
    const clasCAB = useStylesCAB();
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [prevent, setPrevent] = React.useState(true);
    const [rptParams, setRptParams] = React.useState(valueTwalat);
    const [uiElement, setUiElement] = useState({});

    const [rptParamsAuto, setRptParamsAuto] = React.useState(AutoValueTawla);
    const clasBA = useStylesBA();
   
    const dataTawla = AutoOptions?.tawla.map((row, i) => {
        return {
            ...row,
            branchName: AutoOptions?.Branches.find((obj) => obj.id === row.branch)?.name,
            TypeName:isGroups?  typeTwala.find((obj) => obj.id === row.Type)?.name:
            AutoOptions?.tawla_group.find((obj) => obj.id === row?.tawla_group)?.Name

        };
    });
    const [tawlaReport, setTawlaReport] = React.useState(dataTawla);

    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const timer = React.useRef();
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});
    const his = useHistory();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success?.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };
    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };


    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue.id });
        setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
        if (propName === "branch") {
            setBranch(newValue);
        }
    };

    const onRowClick = async (row) => {
        setPrevent(false);
        let res = { branch: {}, tawla_group: {}, Type: {} };

        typeTwala.map((x) => {
            if (x.id == row.Type) res.Type = x;
        });
        tawlagroups.map((x) => {
            if (x.id == row.tawla_group) res.tawla_group = x;
        });
        AutoOptions.Branches.map((x) => {
            if (x.id == row.branch) res.branch = x;
        });

        setRptParamsAuto({
            ...AutoValueTawla,
            branch: res.branch,
            tawla_group: res.tawla_group,
            Type: res?.Type,
        });

        setRptParams({
            ...rptParams,
            id: row.id,
            create_user: row.create_user,
            update_user: sto.idi,
            branch: row.branch,
            Type: row?.Type,
            Name: row.Name,
            tawla_group: row?.tawla_group,
            update_date:moment(new Date()).format('YYYY-MM-DD'),
            date:row.date,
        });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            Tawla:  true,
            parms: {
                iempid: sto.empi,
                tname: isGroups?"tawlagroup": "tawla",
                branch: sto.branchi
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                const dataTawla = res.data?.tawla.map((row, i) => {
                    return {
                        ...row,
                        branchName: AutoOptions?.Branches.find((obj) => obj.id === row.branch)?.name,
                        TypeName:isGroups?  typeTwala.find((obj) => obj.id === row.Type)?.name:
                        AutoOptions?.tawla_group.find((obj) => obj.id === row?.tawla_group)?.Name
            
                    };
                });
                setTawlaReport(dataTawla);
                setRptParams({
                    ...
                    valueTwalat,
                    id: res.data.other?.lastid
                });
                setRptParamsAuto(AutoValueTawla);
            })
            .catch((error) => {
            });
    };

    const handNewTawla = () => {
        reloadGets();
        setRptParamsAuto(AutoValueTawla);
        setRptParams(valueTwalat);
        setPrevent(true);
    };
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "save") { handNewTawla(); }
            if (prop === "update") { handNewTawla(); }

            else if (prop === "delete") { handNewTawla(); }
            else {
                handNewTawla();
            }
            setPrevent(true);
        }, 2000);
    };

    const will = () => {
        let ob =true;
        if (rptParams.Name === null && rptParams.Name ==="")ob=false;
        else if (rptParams.Type === null && rptParams.Type ===-1)ob=false;
        else if ((rptParams.tawla_group === null && rptParams.tawla_group ===- 1) && !isGroups)ob=false;
        return ob;
      };

    const addToBS = (props) => {
        let urls=isGroups? "TawlaGroups": "Tawla";
        ButtonLoading("save");
        let check=will();
        if (check) {
            prevent
                ? axios
                    .post(uri +urls, rptParams)
                    .then((res) => {
                        if (res.data?.data != null) {

                            ButtonSuccess("save", 1000);
                            toast.success(t("save-success"));
                        } else {
                            ButtonSuccess("save", 1000);
                            toast.success(t("save-success"));
                        }

                    })
                    .catch((res) => {
                        ButtonSuccess("save", 1000);
                        toast.error(t("save-failed"));

                    })
                :
                axios
                    .put(uri +urls, rptParams)
                    .then((res) => {
                        ButtonSuccess("update", 1000);
                        toast.success(t("update-success"));
                    })
                    .catch((res) => {
                        ButtonSuccess("update", 1000);
                        toast.error(t("update-failed"));

                    });
        } else {
            alert(t("complete-data"));
        }
    };



    const handleDeleteRow = async (e, row) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let urls=isGroups? `TawlaGroups?id=${row?.id}` :  `Tawla?id=${row?.id}`;

        await axios.delete(uri +urls).then(res => {
            if (res.data==="no"){
                alert(t("cant-delete-table")); 
            }else{
                toast.success(t("delete-success"));
                ButtonSuccess("delete", 1000);
            }

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };

    const deleteToI = async (e) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let urls= isGroups?  `TawlaGroups?id=${rptParams?.id}` :  `Tawla?id=${rptParams?.id}`;

        await axios.delete(uri +urls).then(res => {
            toast.success(t("delete-success"));
            ButtonSuccess("delete", 1000);
        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
                    color="primary"
                >
                    {isGroups ? t("define-sessions") : t("define-tables")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12}className={clasui.rootchip} >

                    <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip} >

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <TawlaForm
                                {...{
                                    AutoOptions,
                                    rptParams,
                                    rptParamsAuto,
                                    onChangeAutoData,
                                    changTField,
                                    isGroups,
                                    typeTwala
                                }}
                            />

                        </Container>
                    </Grid>
                    <Grid container lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                marginTop: "0.5rem"
                            }}
                        >
                            <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.red[300]} />
                                    {!fetching && (
                                        <TawlaTable
                                            {...{
                                                data: tawlaReport ? tawlaReport : [],
                                                setConfirmDialog,
                                                handleDeleteRow,
                                                onRowClick,
                                                isGroups
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                <DeleteConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Typography>
            <PumpsAppbar {...{
                rptParams,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent
            }}
            />
        </div>
    );
}
